
import React from 'react';

export const LogoutIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    logout
  </span>
);